<template>
  <div class="addclassify">
    <el-form
      :model="classifyForm"
      :rules="newsRules"
      ref="classifyForm"
      class="demo-classifyForm"
      label-position="left"
    >
      <el-form-item label="分类名称：" prop="name">
        <el-input
          maxlength="10"
          v-model="classifyForm.name"
          placeholder="请输入分类名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="分类图标：" prop="icon">
        <upload-img
          :fixedNumber="[1, 1]"
          fixedName="1:1"
          accept="image/*"
          tip="只支持 1:1 尺寸"
          uploadName="上传图标"
          @uploadInfo="uploadInfo"
          :fixedFlag="true"
          fileDir="classify"
          :resultImg="classifyForm.icon"
        />
      </el-form-item>
      <el-form-item label="排序号：" prop="sort">
        <el-input
          v-model="classifyForm.sort"
          placeholder="请输入排序号"
        ></el-input>
      </el-form-item>
      <span class="tips">排序号越大，展示位置越靠前</span>
      <el-form-item label="是否展示首页：">
        <el-switch
          v-model="classifyForm.recommendShow"
          :disabled="classnumber === 2 ? true : false"
        ></el-switch>
      </el-form-item>
      <el-form-item class="handlebox">
        <el-button
          type="primary"
          @click="submitForm('classifyForm')"
          class="enter-btn save-btn"
          :loading="submitLoading"
          >保存</el-button
        >
        <el-button
          @click="resetForm('classifyForm')"
          class="cancel-btn calloff-btn"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// import { uploadOss } from "@/api/login";
import { setClassify } from "@/api/shop";
import UploadImg from "../../../components/UploadImg";
export default {
  name: "addarticle",
  components: {
    UploadImg,
  },
  data() {
    return {
      id: null,
      classnumber: 1,
      classifyForm: {
        name: "", // 分类名称
        sort: "", //排序号 从大到小
        recommendShow: false, //是否启用
        icon: "", //消息公告封面
      },
      newsRules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序号", trigger: "blur" }],
        icon: [
          { required: true, message: "请上传消息公告图标", trigger: "change" },
        ],
      },
      submitLoading: false,
      type: "add",
    };
  },
  async created() {
    this.type = this.$route.query.type;
    this.id = this.$route.query.id;
    this.classnumber = Number(this.$route.query.classnumber);
    // console.log("this.classnumber :>> ", typeof this.classnumber);
    if (this.type === "edit") {
      // const res = await getInfoDetais({ id: this.id });
      this.classifyForm = JSON.parse(localStorage.getItem("classify"));
      // this.classifyForm = res.result;
      this.classifyForm.recommendShow =
        this.classifyForm.recommendShow === 1 ? true : false;
      // console.log(this.classifyForm);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    // 获取上传封面
    uploadInfo(info) {
      this.classifyForm.icon = info;
    },
    // 新建资讯
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.type === "add" && this.classnumber === 1) {
            let params = this.classifyForm;
            params.recommendShow = this.classifyForm.recommendShow ? 1 : 0;
            await setClassify(params);
            this.$message.success("添加成功！");
            this.$router.go(-1);
            return;
          }
          if (this.type === "add" && this.classnumber === 2) {
            let params = this.classifyForm;
            params.recommendShow = this.classifyForm.recommendShow ? 1 : 0;
            params.parentId = this.id;
            await setClassify(params);
            this.$message.success("添加成功！");
            this.$router.go(-1);
            return;
          }
          if (this.type === "edit" && this.classnumber === 1) {
            const { icon, name, recommendShow, sort, id } = this.classifyForm;
            let params = {
              icon,
              name,
              recommendShow: recommendShow ? 1 : 0,
              sort,
              id,
            };
            await setClassify(params);
            this.$message.success("修改成功！");
            this.$router.go(-1);
            localStorage.removeItem("classify");
            return;
          }
          const { icon, name, recommendShow, sort, id } = this.classifyForm;
          let params = {
            icon,
            name,
            recommendShow: recommendShow ? 1 : 0,
            sort,
            id,
            parentId: this.id,
          };
          await setClassify(params);
          this.$message.success("修改成功！");
          this.$router.go(-1);
          localStorage.removeItem("classify");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      // this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.addclassify {
  ::v-deep .demo-classifyForm {
    .el-form-item__label {
      white-space: nowrap;
      min-width: 120px;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
    }
    .el-input {
      width: 380px;
    }
    .el-textarea {
      width: 50vw;
    }
  }
  .newscontent {
    display: flex;
    span {
      display: block;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      line-height: 20px;
      min-width: 120px;
    }
  }
  .tips {
    margin: 10px 120px;
    color: #a4a4a4;
  }
  .handlebox {
    margin: 50px 0 0 120px;
  }
}
</style>
<style>
p {
  margin: 10px;
}

.edit_container,
.quill-editor {
  height: 300px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14" !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14" !important;
  font-size: 14px;
}

.ql-size-14px {
  font-size: 14px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16" !important;
  font-size: 16px;
}

.ql-size-16px {
  font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18" !important;
  font-size: 18px;
}

.ql-size-18px {
  font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20" !important;
  font-size: 20px;
}

.ql-size-20px {
  font-size: 20px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "22" !important;
  font-size: 22px;
}

.ql-size-22px {
  font-size: 22px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
  content: "26" !important;
  font-size: 26px;
}

.ql-size-26px {
  font-size: 26px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28" !important;
  font-size: 28px;
}

.ql-size-28px {
  font-size: 28px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30" !important;
  font-size: 30px;
}

.ql-size-30px {
  font-size: 30px;
}
</style>
